import { AppId } from '@inno-tools/container-bridge'
import { useAvailableApps } from 'modules/app-registry/hooks/useAvailableApps'
import { FullPageAppTemplate } from 'modules/app-registry/templates'
import { useLocation, useNavigate } from 'react-router-dom'
import { useHistory, useUserContext } from 'shared/hooks'

const ClusterSlidesApp = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const history = useHistory()
  const { user } = useUserContext()
  const { apps } = useAvailableApps()

  return (
    <FullPageAppTemplate
      appId={AppId.CLUSTER_SLIDES}
      scope='cluster_office'
      envKey={apps[AppId.CLUSTER_SLIDES].runtimeEnvKey}
      entryPath='./ClusterOfficeApp'
      url={process.env.REACT_APP_CLUSTER_OFFICE_APP_DEV_PATH}
      cdnUrl={apps[AppId.CLUSTER_SLIDES].cdnUrl}
      hasFullHeight
      appName={apps[AppId.CLUSTER_SLIDES].name}
      appProps={{
        user,
        initialPath: apps[AppId.CLUSTER_SLIDES].path,
        appType: 'slides',
        defaultHistory: history,
        onNavigate: ({ pathname: nextPathname }: { pathname: string }) => {
          const { pathname } = location

          if (pathname !== nextPathname) {
            navigate(nextPathname)
          }
        }
      }}
    />
  )
}

export { ClusterSlidesApp }
